export default "__VITE_ASSET__CkxxlrkR__"